import { defineMessages } from 'react-intl';

export default defineMessages({
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  EXPIRED: 'Finished',
  SCHEDULED: 'Scheduled',
  MISSING_POLICY: 'Missing policy',
  MISSING_POLICY_tooltip: 'A privacy policy for the same language needs to be added when the customer is a personal data controller. You can add a privacy policy in the <accountPrivacyLink>account settings</accountPrivacyLink>.',
  MISSING_LICENSE: 'No license',
  LICENSE_LIMIT: 'Over license limit',
  LICENSE_LIMIT_tooltip: 'You have more active surveys on the website than your license allows.',
});
